import React from 'react';
import Modal from 'components/UI/Modal';
import { connect } from 'react-redux';
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import { fetchLessonAttendance } from './ducks'
import { fetchClassLesson } from 'containers/pages/ClassDetail/ducks'

const mapStateToProps = (state) => ({
  attendanceDetail: state.lessonAttendanceDetail,
  classDetail: state.classLessonDetail
})

class ModalBody extends React.Component {

  constructor(props){
    super(props)
  }

  componentWillMount(){
    const { lessonId, classId, classDetail } = this.props
    const { dispatch } = this.props
    dispatch(fetchLessonAttendance(lessonId))

    // NOTE: Ryan,
    // Redux state classLessonDetail does not always have states,
    // sometimes it is empty. Then we use classId to fetch it.
    if (Object.keys(classDetail.detail).length < 1) {
      if (!classId) {
        throw new Error('classLessonDetail in Redux is empty. You need to pass opts.classId to this modal in order to load the class.');
      }
      dispatch(fetchClassLesson(classId,{
        amount_per_page: 25,
        current_page_number: 1
      }))
    }
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
      lessonId,
      dispatch
    } = this.props;

    let {
      fetching,
      start_datetime
    } = this.props.attendanceDetail;
		return (
      <Modal
				className='attendance-modal'
				hasHeader={true}
        hasFooter={true}
				headerTitle={__("Attendance", "classdetail")}
				headerIcon="fa icon-ok"
        fixedWidth={560}
        contentHeight={370}
        onCloseModalClick={()=> proceed({start_datetime: start_datetime}) }
        footerType="grey"
        footerButtons={[
          {
            title: __('Complete', 'appwrapper'),
            className: 'btn btn-primary pull-right',
            onClick: () => {
              proceed({start_datetime: start_datetime});
            }
          }
        ]}
        isShowingModal={show} >
        <ModalContent
          fetching={fetching}
          {...this.props}
         />
			</Modal>
    );
  }
}

export default connect(mapStateToProps)(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/Attendance/ModalBody.js